/* 常量文件 */
// 会议室房间排序
export const meetingRankSort = [
  {
    value: 1,
    label: '楼层升序'
  },
  {
    value: 2,
    label: '楼层降序'
  },
  {
    value: 3,
    label: '会议室大小升序'
  },
  {
    value: 4,
    label: '会议室大小降序'
  },
  {
    value: 5,
    label: '智能排序'
  }
]
// 会议室类型
export const meetingRoomType = [
  {
    value: 0,
    label: '普通'
  }, {
    value: 1,
    label: '特殊'
  }
]
// 会议类型
export const meetingType = [
  {
    value: 0,
    label: '公司会议'
  }, {
    value: 1,
    label: '部门会议'
  }, {
    value: 2,
    label: '外部会议'
  }
]
// 员工部门
export const departmentList = [
  {
    value: '综合部',
    label: '综合部'
  }, {
    value: '礼宾部',
    label: '礼宾部'
  }, {
    value: '总经办',
    label: '总经办'
  }, {
    value: '维修部',
    label: '维修部'
  },
  {
    value: '产品研发部',
    label: '产品研发部'
  }, {
    value: '副总经理',
    label: '副总经理'
  }, {
    value: '规划开发部',
    label: '规划开发部'
  }, {
    value: '集成方案部',
    label: '集成方案部'
  },
  {
    value: '金融科技部',
    label: '金融科技部'
  }, {
    value: '数智能力部',
    label: '数智能力部'
  }, {
    value: '物联能力部',
    label: '物联能力部'
  }, {
    value: '业务与支撑部',
    label: '业务与支撑部'
  },
  {
    value: '业务与支撑部（财务团队）',
    label: '业务与支撑部（财务团队）'
  }, {
    value: '业务与支撑部（产业合作团队）',
    label: '业务与支撑部（产业合作团队）'
  }, {
    value: '业务与支撑部（党群团队）',
    label: '业务与支撑部（党群团队）'
  }, {
    value: '业务与支撑部（工会团队）',
    label: '业务与支撑部（工会团队）'
  },
  {
    value: '业务与支撑部（区域拓展团队）',
    label: '业务与支撑部（区域拓展团队）'
  }, {
    value: '业务与支撑部（全国拓展团队）',
    label: '业务与支撑部（全国拓展团队）'
  }, {
    value: '业务与支撑部（人力团队）',
    label: '业务与支撑部（人力团队）'
  }, {
    value: '业务与支撑部（综合团队）',
    label: '业务与支撑部（综合团队）'
  },
  {
    value: '云能力部',
    label: '云能力部'
  }, {
    value: '专业顾问',
    label: '专业顾问'
  }
]
// 物业工单报修类型
export const repairList = [
  {
    value: 1,
    label: '水电维修'
  }, {
    value: 2,
    label: '机械维修'
  }, {
    value: 3,
    label: '空调维修'
  }
]
// 性别
export const sexList = [
  {
    value: 1,
    label: '男'
  }, {
    value: 2,
    label: '女'
  }
]
// 访客审批结果
export const applyStatus = [
  {
    value: 0,
    label: '未审核'
  },
  {
    value: 1,
    label: '通过'
  },
  {
    value: 2,
    label: '未通过'
  }
]
// 设备系统类型
export const deviceSystem = [
  {
    value: 0,
    label: '全部'
  },
  {
    value: 1,
    label: '工位系统'
  },
  {
    value: 2,
    label: '家居系统'
  }
]
// 设备系统类别
export const deviceSystemType = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 'BA',
    label: 'BA系统'
  },
  {
    value: 'HK',
    label: '海康安防系统'
  },
  {
    value: 'Monitor',
    label: '视频监控系统'
  }
]
// 设备子系统类型
export const subBA = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 'ventilator',
    label: '吊顶新风机组'
  },
  {
    value: 'aircooled_heat_pump',
    label: '风冷热泵机组'
  },
  {
    value: 'constant_pressure_water_supply',
    label: '定压补水装置'
  },
  {
    value: 'watertank',
    label: '水箱'
  },
  {
    value: 'ac_pump',
    label: '空调循环水泵'
  },
  {
    value: 'power_substation',
    label: '变电所'
  },
  {
    value: 'fire_alarm',
    label: '火灾报警'
  }
]
export const subHK = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 'gate',
    label: '门禁'
  },
  {
    value: 'lift',
    label: '电梯'
  }
]
export const subMonitor = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 'black_list',
    label: '黑名单'
  }
]
export const SubSystemTypeAll = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 'ventilator',
    label: '吊顶新风机组'
  },
  {
    value: 'aircooled_heat_pump',
    label: '风冷热泵机组'
  },
  {
    value: 'constant_pressure_water_supply',
    label: '定压补水装置'
  },
  {
    value: 'watertank',
    label: '水箱'
  },
  {
    value: 'ac_pump',
    label: '空调循环水泵'
  },
  {
    value: 'power_substation',
    label: '变电所'
  },
  {
    value: 'fire_alarm',
    label: '火灾报警'
  },
  {
    value: 'gate',
    label: '门禁'
  },
  {
    value: 'lift',
    label: '电梯'
  },
  {
    value: 'black_list',
    label: '黑名单'
  }
]

// 告警类型
export const warnType = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 'security_alarm',
    label: '安防告警'
  },
  {
    value: 'data_alarm',
    label: '业务告警'
  },
  {
    value: 'device_alarm',
    label: '设备告警'
  }
]
// 设备子系统类型
export const deviceSubSystem = [
  {
    value: 0,
    label: '监控系统'
  },
  {
    value: 1,
    label: '工位系统'
  },
  {
    value: 2,
    label: '门禁系统'
  }
]
// 设备状态
export const deviceStatus = [
  {
    value: 0,
    label: '正常'
  },
  {
    value: 1,
    label: '异常'
  }
]
// 告警处理状态结果
export const handleStatus = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 0,
    label: '未处理'
  },
  {
    value: 1,
    label: '已派遣'
  },
  {
    value: 2,
    label: '已完成'
  }
]
// 告警类型
export const warnList = [
  {
    value: 0,
    label: '徘徊告警'
  },
  {
    value: 1,
    label: '久坐告警'
  },
  {
    value: 2,
    label: '烟雾告警'
  }
]
// 设备运行状态
// 空调、风冷热泵-运行/水流开关、定压补水、
// 新风机组-运行/风机压差/风机加湿器/水阀开度、电力系统-变压器/柴油发电机
export const runStatus = [
  {
    value: 0,
    label: '停止'
  },
  {
    value: 1,
    label: '运行'
  }
]
// 设备故障状态,水箱高低液位
export const faultStatus = [
  {
    value: 0,
    label: '正常'
  },
  {
    value: 1,
    label: '故障'
  }
]
// 设备手自动状态
export const autoStatus = [
  {
    value: 0,
    label: '手动'
  },
  {
    value: 1,
    label: '自动'
  }
]
// 设备阀门状态、风机风阀状态
export const valveStatus = [
  {
    value: 0,
    label: '关闭'
  },
  {
    value: 1,
    label: '打开'
  }
]
// 电梯上行信号
export const upStatus = [
  {
    value: 0,
    label: '无上行'
  },
  {
    value: 1,
    label: '上行'
  }
]
// 电梯下行信号
export const downStatus = [
  {
    value: 0,
    label: '无下行'
  },
  {
    value: 1,
    label: '下行'
  }
]
// 电梯打开
export const openStatus = [
  {
    value: 0,
    label: '无开门状态'
  },
  {
    value: 1,
    label: '开门状态'
  }
]
// 电梯关闭
export const closeStatus = [
  {
    value: 0,
    label: '无关门状态'
  },
  {
    value: 1,
    label: '关门状态'
  }
]
// 电梯、电力系统-变压器/母联故障状态
export const liftFaultStatus = [
  {
    value: 0,
    label: '正常'
  },
  {
    value: 1,
    label: '报警'
  }
]
// 滤网压差状态
export const filterStatus = [
  {
    value: 0,
    label: '正常'
  },
  {
    value: 1,
    label: '堵塞'
  }
]
// 母联开关状态
export const switchStatus = [
  {
    value: 0,
    label: '断开失联'
  },
  {
    value: 1,
    label: '闭合运行'
  }
]
// 巡检巡更人员列表角色
export const patrolRole = [
  {
    value: 0,
    label: '安保人员'
  },
  {
    value: 1,
    label: '安保管理人员'
  }
]
// 巡检任务状态
export const taskStatus = [
  {
    value: 0,
    label: '未生效'
  },
  {
    value: 1,
    label: '已生效'
  },
  {
    value: 2,
    label: '待巡检'
  }
]
// 巡检临时任务处理状态
export const taskCompleteState = [
  {
    value: 0,
    label: '待巡检'
  },
  {
    value: 1,
    label: '未完成'
  },
  {
    value: 2,
    label: '已完成'
  }
]
// 添加巡查项输入模式
export const entryMode = [
  {
    value: true,
    label: '二选一'
  },
  {
    value: false,
    label: '输入框'
  }
]
// 添加巡查项反馈可选项
export const reChoose = [
  {
    value: 1,
    label: '是/否'
  },
  {
    value: 2,
    label: '确认/取消'
  },
  {
    value: 3,
    label: '正常/异常'
  }
]
export const week = [
  {
    value: 1,
    label: '星期一'
  },
  {
    value: 2,
    label: '星期二'
  },
  {
    value: 3,
    label: '星期三'
  },
  {
    value: 4,
    label: '星期四'
  },
  {
    value: 5,
    label: '星期五'
  },
  {
    value: 6,
    label: '星期六'
  },
  {
    value: 7,
    label: '星期日'
  }
]
export const completeState = [
  {
    value: true,
    label: '是'
  },
  {
    value: false,
    label: '否'
  }
]

// 工位属性
export const seatType = [
  {
    value: 1,
    label: '固定'
  },
  {
    value: 2,
    label: '共享'
  }
]

// 公告状态
export const noticeStatus = [
  {
    value: 0,
    label: '待发布'
  },
  {
    value: 1,
    label: '已发布'
  }
]

// 公告排序
export const noticeSequence = [
  {
    value: 0,
    label: '置顶'
  },
  {
    value: 1,
    label: '一般'
  }
]
// 数据字典的数据分类
export const dataType = [
  {
    value: 1,
    label: '部门'
  },
  {
    value: 2,
    label: '楼层'
  },
  {
    value: 3,
    label: '区域'
  },
  {
    value: 4,
    label: '职务/职位'
  },
  {
    value: 5,
    label: '会议室设备'
  }
]
// 审核状态
export const ApprovalStatus = [
  {
    value: 0,
    label: '待审核'
  },
  {
    value: 1,
    label: '已通过'
  },
  {
    value: 2,
    label: '已拒绝'
  },
  {
    value: '3',
    label: '转办'
  },
  {
    value: 10,
    label: '暂存'
  }
]
export const AttendanceStatus = [
  {
    value: -1,
    label: ''
  },
  {
    value: 0,
    label: '正常'
  },
  {
    value: 1,
    label: '异常-迟到'
  },
  {
    value: 2,
    label: '异常-早退'
  },
  {
    value: 3,
    label: '异常-迟到早退'
  },
  {
    value: 4,
    label: '正常-请假'
  },
  {
    value: 5,
    label: '异常-缺勤'
  }
]

// 用章类型
export const sealList = [
  {
    value: 0,
    label: '财务章'
  },
  {
    value: 1,
    label: '合同章'
  },
  {
    value: 2,
    label: '公司章'
  },
  {
    value: 2,
    label: '法人章'
  },
  {
    value: 4,
    label: '档案章'
  },
]
// 费用类型
export const feeTypeList = [
  {
    label: '工程费',
    value: '工程费'
  },
  {
    label: '办公费',
    value: '办公费'
  },
  {
    label: '差旅费',
    value: '差旅费'
  },
  {
    label: '工资薪金',
    value: '工资薪金'
  },
  {
    label: '公积金',
    value: '公积金'
  },
  {
    label: '社保',
    value: '社保'
  },
  {
    label: '个税',
    value: '个税'
  },
  {
    label: '各项税金',
    value: '各项税金'
  },
  {
    label: '水电费',
    value: '水电费'
  },
  {
    label: '银行手续费',
    value: '银行手续费'
  },
  {
    label: '物业管理费',
    value: '物业管理费'
  },
  {
    label: '维修费',
    value: '维修费'
  },
  {
    label: '保养费',
    value: '保养费'
  },
  {
    label: '电信电话费',
    value: '电信电话费'
  },
  {
    label: '财产保险费',
    value: '财产保险费'
  },
  {
    label: '员工体检费',
    value: '员工体检费'
  },
  {
    label: '医药费',
    value: '医药费'
  },
  {
    label: '押金返还',
    value: '押金返还'
  },
  {
    label: '审计费',
    value: '审计费'
  },
  {
    label: '设计费',
    value: '设计费'
  },
  {
    label: '车辆类',
    value: '车辆类'
  },
  {
    label: '其他',
    value: '其他'
  }
]
// 付款状态
export const payList = [
  {
    label: '未付款',
    value: false
  },
  {
    label: '已付款',
    value: true
  },
]
// 车辆状态
export const carTypeList = [
  {
    label: '空闲',
    value: '空闲'
  },
  {
    label: '保养',
    value: '保养'
  },
  {
    label: '在用',
    value: '在用'
  },
  {
    label: '维修',
    value: '维修'
  }
]